import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hqwisepobreport',
  template: require('./hqwisepobreport.component.html'),
  styles: []
})
export class HQWisePOBReportComponent implements OnInit {

  expDetails: any;
  private columnDefs;
  private rowData;
  private rowHeight;
  api: any;
  columnApi: any;
  defaultColDefine;
  private gridColumnApi;
  private detailCellRendererParams;
  currentMonth: any;

  staffTypes: any;
  staff: any;
  designation: any;
  currentDate: any;



  constructor(

  ) {
    this.columnDefs = [
      { headerName: 'S.No.', field: 'sno', width: 80 },
      { headerName: 'State', field: 'state', width: 200 },
      { headerName: 'Date', field: 'date' },
      { headerName: 'Employee', field: 'employee' },
      { headerName: 'Head Qtr', field: 'head_qtr', width: 150 },
      { headerName: 'Customer Type', field: 'customer_type', width: 150 },
      { headerName: 'Customer Name', field: 'customer_name' },
      { headerName: 'Product Code', field: 'product_code' },
      { headerName: 'Product Name', field: 'product_name' },
      { headerName: 'POB Qty', field: 'pob_qty' },
      { headerName: 'POB Value', field: 'pob_value' },
    ];
    this.defaultColDefine = { resizable: true };
    this.rowData = [
      { sno: '1', state: 'Delhi', date: "02/03/2021", employee: "Bevara Mohan", head_qtr: "Visakhapatnam", customer_type: "C", customer_name: "Prem Medical Store", product_code: "995", product_name: "Entair Compressor", pob_qty: "1", pob_value: "1092.55" }
    ];
    this.rowHeight = 50;
  }
  ngOnInit() {
  }

  onGridReady = (params) => {
    this.api = params.api;
  }
}
